export default __webpack_public_path__ + "static/media/Support-Scenario-Menu-C.be827556.png";